import { render, staticRenderFns } from "./ModalPhotos.vue?vue&type=template&id=0a0de212"
import script from "./ModalPhotos.vue?vue&type=script&lang=js"
export * from "./ModalPhotos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports